import { defineMessages } from 'react-intl';

export default defineMessages({
  organization: {
    id: 'organization',
    defaultMessage: 'Organization',
  },
  company: {
    id: 'company',
    defaultMessage: 'Company',
  },
  employee: {
    id: 'employee',
    defaultMessage: 'Employee',
  },
  employeeRoles: {
    id: 'employeeRoles',
    defaultMessage: 'Employee Roles',
  },
});
